import { render, staticRenderFns } from "./pub-need.vue?vue&type=template&id=7dc513da&scoped=true"
import script from "./pub-need.vue?vue&type=script&lang=js"
export * from "./pub-need.vue?vue&type=script&lang=js"
import style0 from "./pub-need.vue?vue&type=style&index=0&id=7dc513da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc513da",
  null
  
)

export default component.exports